import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@/common/utils/requireFeature';
import { FeatureKey } from '@/common/enums/feature-keys.enum';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { PlaybookTemplatesPage } from '@/features/playbooks/components/PlaybookTemplatesPage';

export const Route = createFileRoute('/_authenticated/playbooks/templates')({
  beforeLoad: async () => {
    await requireFeature(FeatureKey.CLIENT_PLAYBOOKS);
  },
  component: PlaybookTemplatesRoute,
});

function PlaybookTemplatesRoute() {
  return (
    <PermissionGate permission={Permission.PLAYBOOKS_CONFIGURE}>
      <PlaybookTemplatesPage />
    </PermissionGate>
  );
}
